import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { HistorySetting } from '~/models/administration/historySetting';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class HistorySettingsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.adminStock);
  }

  getHistorySetting(): Observable<HistorySetting> {
    return this.http.get<HistorySetting>(this._url());
  }

  updateHistorySetting(model: HistorySetting): Observable<any> {
    return this.client.put(this._url(), model);
  }

  private _url(v?: string): string {
    v = v || '';
    return this.url(`/HistorySettings${v}`);
  }
}
